module.exports = __webpack_public_path__ + "img/rollback.a924a297.svg";